module.exports = __webpack_public_path__ + "img/DK27748562.6062e4f7.png";